import React, { useState } from 'react';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';

const Pagination = ({
  currentPage,
  totalItems,
  itemsPerPage,
  onPageChange,
  onItemsPerPageChange,
  className = ''
}) => {
  const [inputValue, setInputValue] = useState(itemsPerPage);
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const handleItemsPerPageChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
  };

  const handleItemsPerPageSubmit = (e) => {
    e.preventDefault();
    const newValue = parseInt(inputValue, 10);
    if (newValue > 0) {
      onItemsPerPageChange(newValue);
    }
  };

  return (
    <div className={`flex flex-col sm:flex-row items-center justify-between gap-4 px-4 py-3 bg-white border-t border-gray-200 sm:px-6 ${className}`}>
      <div className="flex flex-col items-center w-full gap-4 sm:flex-row sm:w-auto">
        {/* <span className="text-sm text-gray-700 whitespace-nowrap">
          {startItem} - {endItem} of {totalItems} items
        </span> */}
        <span className="text-sm text-gray-700 whitespace-nowrap">
          {startItem} - {endItem} of{' '}
          <span className="font-semibold text-blue-600">{totalItems}</span> items
        </span>

        <form onSubmit={handleItemsPerPageSubmit} className="flex items-center gap-2">
          <span className="text-sm text-gray-700 whitespace-nowrap">Show</span>
          <input
            type="number"
            min="1"
            value={inputValue}
            onChange={handleItemsPerPageChange}
            className="block w-16 py-1 pl-3 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
          <span className="text-sm text-gray-700 whitespace-nowrap">per page</span>
          <button
            type="submit"
            className="px-2 py-1 text-sm focus:outline-none whitespace-nowrap"
          >
            Go
          </button>
        </form>
      </div>
      <div className="flex items-center justify-center w-full gap-2 sm:w-auto sm:justify-end">
        <button
          onClick={handlePrevious}
          disabled={currentPage === 1}
          className={`inline-flex items-center px-3 py-1.5 border border-gray-300 text-sm font-medium rounded-md whitespace-nowrap ${currentPage === 1
            ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
            : 'bg-white text-gray-700 hover:bg-gray-50'
            }`}
        >
          <BsChevronLeft className="w-4 h-4 mr-1" />
          Previous
        </button>
        <button
          onClick={handleNext}
          disabled={currentPage === totalPages}
          className={`inline-flex items-center px-3 py-1.5 border border-gray-300 text-sm font-medium rounded-md whitespace-nowrap ${currentPage === totalPages
            ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
            : 'bg-white text-gray-700 hover:bg-gray-50'
            }`}
        >
          Next
          <BsChevronRight className="w-4 h-4 ml-1" />
        </button>
      </div>
    </div>
  );
};

export default Pagination; 